import { apiAction } from 'actions/application'
import { createAction } from 'actions/utils'
import { denormalize } from 'normalizr'
import { solenoidSchema, mod, slotSchema } from 'schemas/ecpModules'
import * as services from 'services/vehicles'

export const ECP_MODULES_STATE_RECEIVED = 'ECP_MODULES_STATE_RECEIVED'
export const getECPModulesState = createAction(ECP_MODULES_STATE_RECEIVED, [
  'ecps',
])

export const LOAD_ECP_PAGE = 'LOAD_ECP_PAGE'
export const loadEcpPage = createAction(LOAD_ECP_PAGE)

export const SOLENOIDS_RECEIVED = 'SOLENOIDS_RECEIVED'
export const getSolenoids = (ecpVariant) =>
  apiAction({
    asyncFn: services.getSolenoids,
    successActionType: SOLENOIDS_RECEIVED,
    args: { ecpVariant },
    id: ecpVariant,
    schema: solenoidSchema,
  })

export const ECP_MODULE_UPDATED = 'ECP_MODULE_UPDATED'
export const ECP_MODULE_UPDATE_FAILED_NOTIFY = 'ECP_MODULE_UPDATE_FAILED_NOTIFY'
export const updateEcpModule = (serialNumber, id, note, module, callback) => {
  const { input, ...rest } = module
  // TODO: find a place where normalize/denormalize can live together
  const denormalizedModule = denormalize({ slots: input }, slotSchema, rest)
  return apiAction({
    asyncFn: services.updateEcp,
    args: { serialNumber, id, module: { note, ...denormalizedModule } },
    successActionType: ECP_MODULE_UPDATED,
    failureActionType: ECP_MODULE_UPDATE_FAILED_NOTIFY,
    schema: mod,
    resolve: callback,
  })
}

export const ADD_ECP = 'ADD_ECP'
export const addEcp = createAction(ADD_ECP, ['id', 'serialNumber'])

export const CLEAR_ECP_STATE = 'CLEAR_ECP_STATE'
export const clearEcpState = createAction(CLEAR_ECP_STATE)

export const ECP_ADD_WARNING_NOTIFY_CLEANUP = 'ECP_ADD_WARNING_NOTIFY_CLEANUP'
export const clearECPAddWarning = createAction(ECP_ADD_WARNING_NOTIFY_CLEANUP)

export const REMOVE_SOLENOID = 'REMOVE_SOLENOID'
export const removeSolenoid = createAction(REMOVE_SOLENOID, ['slotId'])

export const RESET_ECP = 'RESET_ECP'
export const resetEcp = createAction(RESET_ECP, ['id'])

export const ADD_SOLENOID = 'ADD_SOLENOID'
export const addSolenoid = createAction(ADD_SOLENOID, ['id', 'slotId'])

export const UPDATE_ECP = 'UPDATE_ECP'
export const updateEcp = createAction(UPDATE_ECP, [
  'serialNumber',
  'id',
  'note',
  'callback',
])

export const ON_SOLENOID_DRAG = 'ON_SOLENOID_DRAG'
export const onSolenoidDrag = createAction(ON_SOLENOID_DRAG, [
  'draggingSolenoidItem',
])

export const OFF_SOLENOID_DRAG = 'OFF_SOLENOID_DRAG'
export const offSolenoidDrag = createAction(OFF_SOLENOID_DRAG)

export const ON_PNEUMATICS_DROP = 'ON_PNEUMATICS_DROP'
export const onPneumaticsDrop = createAction(ON_PNEUMATICS_DROP, ['dropItem'])

export const ECP_LINKED_FEATURES_RECIEVED = 'ECP_LINKED_FEATURES_RECIEVED'
export const GET_ECP_LINKED_FEATURES = 'GET_ECP_LINKED_FEATURES'
/**
 * Trigger the POST search service for finding features associated with a solenoid.
 * @param {{
 *   moduleType: string,
 *   outputId: string,
 *   serialNumber: string
 * }}
 * @returns
 */
export const fetchEcpLinkedFeatures = ({
  moduleType,
  outputId,
  serialNumber,
}) =>
  apiAction({
    asyncFn: services.getEcpLinkedFeatures,
    args: { moduleType, outputId, serialNumber },
    successActionType: ECP_LINKED_FEATURES_RECIEVED,
    id: `${serialNumber}/${moduleType}/${outputId}`,
  })

export const OPTIONAL_SOLENOIDS_NOT_INSTALLED =
  'OPTIONAL_SOLENOIDS_NOT_INSTALLED'
export const onOptionaSolenoidsLimitExceeded = createAction(
  OPTIONAL_SOLENOIDS_NOT_INSTALLED,
  ['solenoids', 'currentSolenoids', 'features']
)
